module.exports = __webpack_public_path__ + "static/media/address-inactive.ab726fbe.svg";